<template>
<div>
    <form>
        <b-form-group :label="$t('terminals.announcements.announcement')">
            <vSelect :options="announcementOptions" v-model="announcement.tunnus" :reduce="option => option.tunnus" label="otsikko"
                :selectable="(option) => option.tunnus > -2" @option:selected="onSelect" />
        </b-form-group>
        <label>{{ $t('terminals.announcements.name') }}</label>
        <b-form-input v-model="announcement.otsikko" :disabled="disabled" />
        <label>{{ $t('terminals.announcements.content') }}</label>
        <b-form-textarea v-model="announcement.tiedoteTextList['1']" :disabled="disabled" rows="3" max-rows="6" />
        <b-form-group :label="$t('terminals.announcements.start_time')">
            <DateTimePicker v-model="announcement.kelpoisuusalkaa" :disabled="disabled" />
        </b-form-group>
        <b-form-group :label="$t('terminals.announcements.end_time')">
            <DateTimePicker v-model="announcement.kelpoisuusloppuu" :disabled="disabled" />
        </b-form-group>
        <b-form-group :label="$t('terminals.announcements.displays')">
            <div v-for="dg in displayGroups" :key="'dGroup-'+ dg.displayGroupId" class='display-cb-list '>
                <input type="checkbox" :id="'dGroup-'+ dg.displayGroupId" :value="dg.displayGroupId"
                    v-model="attachedGroups" @change="onGroupSelect(dg.displayGroupId)">
                <label class='group' :for="'dGroup-'+ dg.displayGroupId">{{ dg.terminalDisplayGroupName }}</label>
                <div v-for="d in getGroupDisplays(dg.displayGroupId)" :key="'gd-'+ d.displayId">
                    <input type="checkbox" :id="'gd-'+ dg.displayId" :value="d.displayId" v-model="attachedDisplays">
                    <label class='display' :for="'gd-'+ d.displayId">{{ d.name }}</label>
                </div>
            </div>
        </b-form-group>
        <FormButtons
            @submit="onSubmit"
            @reset="onReset"
            @remove="onRemove" :disableRemove="announcement.tunnus == -1"
            :deleteConfirmation="$t('terminals.announcements.delete_confirmation_message')"></FormButtons>
        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
</div>
</template>

<script>
import DateTimePicker from '@/components/Misc/DateTimePicker';
import terminalView from '@/store/terminals/terminalView';
import vSelect from 'vue-select';
import moment from 'moment';

export default {
	name: 'TermDispAnnouncementEditor',
    components: { DateTimePicker, vSelect },
    props: {
        selectedAnnouncement: {
            type: Object,
            //required: true,
            default: () => { return {
                    tunnus: -1,
                    otsikko: '',
                    tiedoteTextList: {},
                    targets: { displayTargets: [] }
                };
            }
        },
        terminalId: { required: true }
    },
    data: function() {
        var checkboxInit = [];
        for (var target of this.selectedAnnouncement.targets.displayTargets) {
            checkboxInit.push(target.id);
        }
        return {
            // selectedAnnouncement is an initial value passed from the parent, announcement is used as the internal value.
            announcement: this.selectedAnnouncement,
            attachedDisplays: checkboxInit,
            attachedGroups: [],
            ok: false,
            error: false,
            loading: false,
            infoType: 'save'
        };
    },
    computed: {
        announcementOptions() {
            var optionList = [];
            optionList.push({
                    tunnus: -1,
                    otsikko: this.$t('terminals.announcements.create_new'),
                    tiedoteTextList: {}
                });
            optionList.push({
                    tunnus: -2,
                    otsikko: '-----',
                    tiedoteTextList: {}
                });
            for (var a of this.$store.state.terminalView.announcementsByTerminal[this.terminalId]) {
                optionList.push(a);
            }
            return optionList;
        },
        displayGroups() {
            for (var terminal of this.$store.state.terminalView.terminalList) {
                if (terminal.terminalId == this.terminalId) {
                    return terminal.displayGroups;
                }
            }
            return [];
        },
        disabled() {
            return this.loading;// || (this.announcement.tunnus && this.announcement.tunnus > -1);
        }
    },
    methods: {
        getGroupDisplays(displayGroupId) {
            return this.$store.state.terminalView.displaysByGroup[displayGroupId];
        },
        onGroupSelect(displayGroupId) {
            if (this.attachedGroups.includes(displayGroupId)) {
                for (let display of this.getGroupDisplays(displayGroupId)) {
                    if (!this.attachedDisplays.includes(display.displayId)) {
                        this.attachedDisplays.push(display.displayId);
                    }
                }
            } else {
                var displayList = [];
                for (let display of this.getGroupDisplays(displayGroupId)) {
                    displayList.push(display.displayId);
                }
                this.attachedDisplays = this.attachedDisplays.filter(i => !displayList.includes(i));
            }
        },
        onSelect(selected) {
            // The internal announcement variable is replaced with a new object.
            this.announcement = { ...selected };
            this.attachedDisplays = [];
            this.attachedGroups = [];
            if (selected.tunnus == -1) {
                // Initialize validity time with the present moment when creating a new announcement.
                this.announcement.kelpoisuusalkaa = new moment().format('YYYY-MM-DD[T]HH:mm:ssZZ');
                this.announcement.kelpoisuusloppuu = this.announcement.kelpoisuusalkaa;
                this.announcement.otsikko = '';
            } else {
                for (var target of selected.targets.displayTargets) {
                    this.attachedDisplays.push(target.id);
                }
            }
        },
        onSubmit(event) {
            if (event)
                event.preventDefault();
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;

            this.announcement.targets.displayTargets = [];
            for (var display of this.attachedDisplays) {
                this.announcement.targets.displayTargets.push({ id: display });
            }
            this.announcement.terminal = this.terminalId;
            this.announcement.tyyppi = 1;
            this.announcement.kiinnitystyyppi = 2;
            this.$store.dispatch('terminalView/addTerminalAnnouncement', { announcement: this.announcement,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = false;
                    if (response.data.errorCode == 0) {
                        this.onReset();
                    } else {
                        this.error = true;
                    }
                }, 1000);
            })
            .catch( () => { this.error = true; })
        },
        onReset() {
            this.ok = this.error = false;
            this.loading = false;
            this.$emit('reset');
        },
        onRemove() {
            this.ok = this.error = false;
            this.infoType = "delete";
            this.loading = true;

            this.announcement.terminal = this.terminalId;
            this.$store.dispatch('terminalView/removeTerminalAnnouncement', { announcement: this.announcement,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = false;
                    if (response.data.errorCode == 0) {
                        this.onReset();
                    } else {
                        this.error = true;
                    }
                }, 1000);
            }, () => {
                    this.ok = false;
                    this.error = !this.ok;
                    this.loading = false;
            });
        }
    },
    created() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
    }
}
</script>